export default __webpack_public_path__ + "static/O0146-7a598fc8f680aaf4a7394dc59d58c6b3.png";